'use strict';

function verification(isValid, isPotentiallyValid, isValidForThisYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isValidForThisYear: isValidForThisYear || false
  };
}
function expirationMonth(value) {
  var month, result;
  var currentMonth = new Date().getMonth() + 1;
  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '' || value === '0') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }
  month = parseInt(value, 10);
  if (isNaN(value)) {
    return verification(false, false);
  }
  result = month > 0 && month < 13;
  return verification(result, result, result && month >= currentMonth);
}
module.exports = expirationMonth;